import { createAsyncThunk } from '@reduxjs/toolkit';
import usePatientRequests from '../../../hooks/patient-requests';
import useDistanceRequests from '../../../hooks/distance-request';

const { getPatients } = usePatientRequests();
const { manuallyGroupPatients } = useDistanceRequests();

export const fetchPatients = createAsyncThunk(
  'patients/fetchPatients', 
  async ({ user, accessToken }, { rejectWithValue }) => {
    try {
      const patientData = await getPatients(user.authId, accessToken);
      if (patientData.status === 500) {
        throw new Error(patientData.message);
      }
      return patientData.message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePatientsGroup = createAsyncThunk(
  'patients/updatePatientsGroup', 
  async ({ user, accessToken, patients }, { rejectWithValue }) => {
    try {
      const patientData = await manuallyGroupPatients(user.authId, accessToken, patients);
      if (patientData.status === 500) {
        throw new Error(patientData.message);
      }
      return patientData.message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

